import { COMMANDBAR_CUSTOMERID } from '@synergy/config';
import { LocalizedProvider } from '@synergy/components';
import { useCommandbar } from '@synergy/components-next';
import { useEffect } from 'react';

import { AppRouter } from './app-router';
import { fetchPositions } from './common/actions/positions-actions';
import { localesSelector } from './common/selectors/locale-selectors';
import { useSelector } from './store/use-appstate-selector';
import { useThunkDispatch } from './store/use-thunk-dispatch';

export const App = () => {
    const locales = useSelector(localesSelector);

    const userId = useSelector(state => state.user.id);
    const dispatch = useThunkDispatch();
    useCommandbar(COMMANDBAR_CUSTOMERID, userId);

    useEffect(() => {
        dispatch(fetchPositions());
    }, [dispatch]);

    return (
        <LocalizedProvider locales={locales}>
            <AppRouter />
        </LocalizedProvider>
    );
};
